import { Modal } from "@app/shared/Modals";
import { QESSelect } from "@app/shared/qes-standards/forms/Select";
import { QESTextInput } from "@app/shared/qes-standards/forms/TextInput";
import { FC, JSX, useEffect, useState } from "react";

interface AddJobQueueModalProps {
  confirmAdd: (queueName: string, workerVersion: number, memorySize: number) => void;
  closeModal: () => void;
  isVisible: boolean;
  existingQueueNames: string[]
}

export const AddJobQueueModal: FC<AddJobQueueModalProps> = (props: AddJobQueueModalProps) => {
    const [queueName, setQueueName] = useState<string>("");
    const [memorySize, setMemorySize] = useState<number>();
    const [workerVersion, setWorkerVersion] = useState<number>(2);

    useEffect(() => {
        if (!props.isVisible) {
            resetState();
        }
    }, [props.isVisible]);

    const uniqueNameValidationText = () => {
        if (props.existingQueueNames.some(q => q == queueName))
            return "Queue name must be unique";  
    };

    const resetState = () => {
        setQueueName("");
        setMemorySize(null);
        setWorkerVersion(2);
    }

    const modalBody: JSX.Element = (
        <div>
            <QESTextInput
                type="text"
                className="mb-1"
                disabled={false}
                testId="job-queues__edit-name-text-box"
                label="Job Queue Name"
                value={queueName}
                errorText={uniqueNameValidationText()}
                isValid={!uniqueNameValidationText()}
                required={true}
                onChange={(e)=> setQueueName(e.target.value)}
            />
            <QESTextInput
                type="text"
                className="mb-1"
                disabled={false}
                testId="job-queues__edit-name-memory-size"
                label="Memory Size"
                value={memorySize}
                onChange={(e)=> setMemorySize(parseInt(e.target.value))}
            />
            <QESSelect
                label="Worker Version"
                onChange={(e) => setWorkerVersion(parseInt(e.target.value, 10))}
                required={true}
                value={workerVersion}
                disabled={false}
                testId="job-queues__edit-worker-version-select">
                <option key="0" value="null" disabled={false}>Select a worker version</option>
                <option key="1" value={1}>1</option>
                <option key="2" value={2}>2</option>
            </QESSelect>
        </div>
    );
    return (
        <Modal
            isVisible={props.isVisible}
            closeModal={props.closeModal}
            hideBodyScroll={true}
            content={{
                body: modalBody,
                cancelButtonText:"Cancel",
                confirmButtonAction:(() => {
                    props.confirmAdd(queueName, workerVersion, memorySize);
                }),
                confirmButtonDisable:queueName.length < 3,
                confirmButtonText:"Confirm",
                title:"Add Job Queue"
            }} />
        );
}
